module.exports = __webpack_public_path__ + "img/detailEnd.f3506383.png";